import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import getColor from "@insite/mobius/utilities/getColor";

filterListStyles.wrapper = mergeToNew(filterListStyles.wrapper, {
    css: css`
        background: ${getColor("secondary")};
        padding: 12px 20px;
        border-radius: 6px;
        margin-bottom: 10px;
    `,
});

filterListStyles.filterText = mergeToNew(filterListStyles.filterText, {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
});
